import { AppLayout } from '@src/components/sco/AppLayout'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'
import { SSRGate } from '@src/components/sco/utilities/SSRGate'
import { ReactNode } from 'react'

type GenericLayoutProps = {
  children: ReactNode
  appLayoutId: string
}

/**
 * Marketing landing in a single-panel AppLayout.
 * Used for guests on /generic-lp and always on /generic-lp/landing.
 */

export const GenericLayout = ({ children, appLayoutId }: GenericLayoutProps) => {
  return (
    <SSRGate disableSSR={true}>
      {/*<HubspotHideChatStyles />*/}
      <AppLayout
        header={<ScoSiteNavBar />}
        id={appLayoutId}
        panels={[
          {
            id: appLayoutId,
            children: children,
            // AppLayout shells at 100vh; the panel must be height-constrained with
            // minHeight:0 so overflowY actually scrolls long content (e.g. goal lists).
            containerProps: {
              bgColor: 'colorPalette.panel',
              height: 'full',
              minHeight: 0,
              overflowY: 'auto',
            },
          },
        ]}
      />
    </SSRGate>
  )
}
